import Axios from "../helper/axios";
import { urls } from "../constants/constants";

const axios = new Axios();

class NotificationService {
  getActiveNotifications(practiceId) {
    const option = {
      url: `${urls.aspariaBackend}api/v1/notification/getActiveNotifications${
        practiceId ? `?practiceId=${practiceId}` : ""
      }`,
    };
    return axios.get(option);
  }
}

const notificationService = new NotificationService();

export default notificationService;
